import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spinner-usage',
  templateUrl: './spinner-usage.component.html',
  styleUrls: ['./spinner-usage.component.sass']
})
export class SpinnerUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
